/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as BadgeDefs from "./defs.defs.js";

const $nsid = "place.stream.badge.getIssuedBadges";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"streamer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"server":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<BadgeDefs.BadgeView>((() => BadgeDefs.badgeView) as any)),"streamer":/*#__PURE__*/ l.ref<BadgeDefs.BadgeSlot>((() => BadgeDefs.badgeSlot) as any),"user":/*#__PURE__*/ l.ref<BadgeDefs.BadgeSlot>((() => BadgeDefs.badgeSlot) as any)});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Returns badges issued to the authenticated user, organized by display slot. Also indicates which badges are currently selected in the user's chat profile. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
